<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-show="!loading">
                    <data-table :headings="productHeadings" :data="products" :hasActions="true"
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @actionClicked="onProductActionClicked" @filterSearchClicked="onFilterSearchClicked">
                        <template #actionButton>
                            <div class="w-100">
                                <button class="btn btn-primary" @click="onAddProductClick">Add Product</button>
                            </div>
                        </template>
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <label>Eligible For</label>
                                        <bootstrap-select  :selectOptions="orderTypes" :selectedOption="filter.orderTypeId" :elementId="'orderTypeTypeFilterSelect'"
                                                           :returnSelectedOptionText="true"
                                                           @changeSelect="onOrderTypeFilterSelect"></bootstrap-select>
                                    </div>
                                    <div class="col-6">
                                        <label for="productTypeFilterSelect">
                                            Product Type
                                        </label>
                                        <bootstrap-select  :selectOptions="productTypesForSelect" :selectedOption="filter.productTypeId" :elementId="'productTypeFilterSelect'"
                                                           :returnSelectedOptionText="true"
                                                           @changeSelect="onProductTypeFilterSelect"></bootstrap-select>
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-6">
                                        <active-inactive-radio-buttons :activeInactiveKey="filter.activeOrInactiveItems"
                                                                       :componentId="'productFilterRadioButtons'"
                                                                       @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

    <mark-as-active-inactive-modal
                :heading="productMarkAsActiveInactiveModal.heading"
                :modalId="productMarkAsActiveInactiveModal.modalId"
                :isSaving="productMarkAsActiveInactiveModal.isSaving"
                :showModal="productMarkAsActiveInactiveModal.showModal"
                :isActive="productMarkAsActiveInactiveModal.isActive"
                @closeClicked="productMarkAsActiveInactiveModal.showModal = false"
                @saveButtonClicked="onMarkAsActiveInactiveSaveClick"></mark-as-active-inactive-modal>
    
    <modal-form
            :heading="productAddEditFormModal.heading"
            :modalId="productAddEditFormModal.modalId"
            :isSaving="productAddEditFormModal.isSaving"
            :showModal="productAddEditFormModal.showModal"
            @closeClicked="onAddOrEditProductModalCloseClick"
            @saveButtonClicked="onAddOrEditProductSaveClick">
        <template #form>
            <form>
                <div class="form-group">
                    <label for="nameInput">
                        Name
                    </label>
                    <div class="text-danger" v-if="productAddEditFormModal.product.name.hasError">
                        {{productAddEditFormModal.product.name.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="nameInput" v-model="productAddEditFormModal.product.name.value"
                            @blur="generateProductCode"/>
                </div>
                <div class="form-group">
                    <label for="productCodeInput">
                        Product Code
                    </label>
                    <div class="text-danger" v-if="productAddEditFormModal.product.productCode.hasError">
                        {{productAddEditFormModal.product.productCode.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="productCodeInput" v-model="productAddEditFormModal.product.productCode.value" disabled/>
                    <p class="text-info" v-if="!productAddEditFormModal.isUpdate">
                        Please note that the product code will be automatically generated when a product name is entered
                    </p>
                </div>
                <div class="form-group">
                    <label for="productTypeSelect">
                        Product Type
                    </label>
                    <div class="text-danger" v-if="productAddEditFormModal.product.productTypeId.hasError">
                        {{productAddEditFormModal.product.productTypeId.errorMessage}}
                    </div>
                    <bootstrap-select  :selectOptions="productTypes" :selectedOption="productAddEditFormModal.product.productTypeId.value" :elementId="'productTypeSelect'"
                                       :returnSelectedOptionText="true"
                                       @changeSelect="onProductTypeSelect"></bootstrap-select>
                </div>
                <div class="form-group">
                    <label for="erpCodeInput">
                        ERP Code
                    </label>
                    <div class="text-danger" v-if="productAddEditFormModal.product.erpCode.hasError">
                        {{productAddEditFormModal.product.erpCode.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="erpCodeInput" v-model="productAddEditFormModal.product.erpCode.value"/>
                </div>
                <div class="text-danger" v-if="productAddEditFormModal.product.allowCollectionDeliveryHasError">
                    {{productAddEditFormModal.product.allowCollectionDeliveryErrorMessage}}
                </div>
                <div class="form-group form-check">
                    <input class="form-check-input" type="checkbox" value="" id="eligibleForCollectionCheckbox" v-model="productAddEditFormModal.product.allowCollection">
                    <label class="form-check-label" for="eligibleForCollectionCheckbox">
                        Eligible for Collection
                    </label>
                </div>
                <div class="form-group form-check">
                    <input class="form-check-input" type="checkbox" value="" id="eligibleForDeliveryCheckbox" v-model="productAddEditFormModal.product.allowDelivery">
                    <label class="form-check-label" for="eligibleForDeliveryCheckbox">
                        Eligible for Delivery
                    </label>
                </div>
                <div class="form-group form-check">
                    <input class="form-check-input" type="checkbox" value="" id="eligibleForExTankCheckbox" v-model="productAddEditFormModal.product.allowExTank">
                    <label class="form-check-label" for="eligibleForExTankCheckbox">
                        Eligible for Ex-Tank
                    </label>
                </div>
            </form>
        </template>
    </modal-form>
</div>
